import {observer} from "mobx-react";
import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";
import Button from "@/components/common/Button";
import {
    ButtonWrap,
    FileUploadArea,
    ImportInfo,
    RequiredStar,
    TitleContentInner,
    TitleContentWrap
} from "@/styles/CommonStyle";
import React, {useEffect, useRef} from "react";
import SelectBox from "@/components/common/SelectBox";
import Input from "@/components/common/Input"
import {downloadFile, fileUpload, setToast} from "@/utils";
import {BsPaperclip} from "react-icons/bs";
import {IoCloseCircleOutline} from "react-icons/io5";
import {useStore} from "@/store";
import {loadDaumPostcode} from "@/utils/loadDaumPostcode";
import {getCurrentNode} from "@/utils/menu";

const CooperationAddModal = observer(({data, menuId, handleCloseModal, modalDepth, confirmFunc}) => {
    const {boardDetailStore, menuStore} = useStore();
    useEffect(() => {
        boardDetailStore.setBoardFormDataReset();
        if(data){
            boardDetailStore.setCooperationInnerData(data);
        }
    }, [data])
    const hideFiles = useRef(null);
    const setFileUpload = () => {
        hideFiles.current.click();
    }
    return(
        <ModalBody>
            <CooperationModalWrap>
                <TitleContentWrap className={"filter-search-wrap"}>
                    <div className={"loc-wrap"}>
                        <TitleContentInner className={"loc-name"}>
                            <div className={"title"}>지역명<RequiredStar>*</RequiredStar></div>
                            <div className={"content"}>
                                <div className={"loc-name-select"}>
                                    <SelectBox
                                        option={LOC_LIST}
                                        size="m"
                                        type="solid"
                                        round={true}
                                        placeholder="선택"
                                        onChange={async (e) => {
                                            console.log(e.value, "asd")
                                            boardDetailStore.setCooperationDataList("locationTitle", e.value)
                                        }}
                                        value={LOC_LIST.find(opt => opt.value === boardDetailStore.listInnerData?.["locationTitle"]) || null}
                                    />
                                </div>
                            </div>
                        </TitleContentInner>
                        <TitleContentInner className={"cooperation-title"}>
                            <div className={"title"}>기업명<RequiredStar>*</RequiredStar></div>
                            <div className={"content"}>
                                <Input
                                    inputType="text"
                                    placeholder="입력해주세요"
                                    width={"fill"}
                                    value={boardDetailStore.listInnerData?.["title"]}
                                    onChange={(e) => {
                                        boardDetailStore.setCooperationDataList("title", e.target.value)
                                    }}
                                />
                            </div>
                        </TitleContentInner>
                    </div>
                    <TitleContentInner>
                        <div className={"title"}>주소<RequiredStar>*</RequiredStar></div>
                        <div className={"content uni-cont"}>
                            <div className={"flex al-center gap-5"}>
                                <Button
                                    type="solid"
                                    size="m"
                                    round={true}
                                    text={"주소"}
                                    onClickFunc={async () => {
                                        try {
                                            const Postcode = await loadDaumPostcode();

                                            const width = 500, height = 600;
                                            const left = window.screenX + (window.outerWidth - width) / 2;
                                            const top = window.screenY + (window.outerHeight - height) / 2;

                                            new Postcode({
                                                oncomplete(data) {
                                                    boardDetailStore.setCooperationDataList("address", data.address);
                                                    boardDetailStore.setCooperationDataList("zonecode", data.zonecode);
                                                    boardDetailStore.setCooperationDataList("detailAddress", "");
                                                },
                                            }).open({ left, top, popupName: "postcode" });
                                        } catch (e) {
                                            console.error(e);
                                            alert("주소검색 스크립트 로딩 실패");
                                        }
                                    }}
                                />
                                <Input
                                    inputType="text"
                                    placeholder="주소 찾기 해주세요"
                                    width={"fill"}
                                    // readOnly={true}
                                    value={boardDetailStore.listInnerData?.["address"]}
                                    onChange={(e) => {
                                        boardDetailStore.setCooperationDataList("address", e.target.value);
                                    }}
                                />
                                <Input
                                    inputType="text"
                                    placeholder="상세주소를 입력해주세요"
                                    width={"fill"}
                                    value={boardDetailStore.listInnerData?.["detailAddress"]}
                                    onChange={(e) => {
                                        boardDetailStore.setCooperationDataList("detailAddress", e.target.value);
                                    }}
                                />
                            </div>
                            <ImportInfo className={"mg"}>
                                *네이버 지도 연동 특성상 검색창에 물결(~) 및 특수문자 포함되면 API 호출이 불가해 상세주소 입력 시 사용자 화면내에 지도마커가 오작동할 수 있습니다.<br />
                                예시 : 경기 성남시 분당구 성남분당우체국사서함 1 ~ 200
                            </ImportInfo>
                        </div>
                    </TitleContentInner>
                    <TitleContentInner>
                        <div className={"title"}>전화번호</div>
                        <div className={"content"}>
                            <div className={"tel-wrap"}>
                                <Input
                                    inputType="text"
                                    placeholder="02"
                                    width={"fill"}
                                    value={boardDetailStore.listInnerData?.["tel01"]}
                                    onChange={(e) => {
                                        boardDetailStore.setCooperationDataList("tel01", e.target.value.replace(/\D/g, '').slice(0, 3));
                                    }}
                                />
                                <span>-</span>
                                <Input
                                    inputType="text"
                                    placeholder="1234"
                                    width={"fill"}
                                    value={boardDetailStore.listInnerData?.["tel02"]}
                                    onChange={(e) => {
                                        boardDetailStore.setCooperationDataList("tel02", e.target.value.replace(/\D/g, '').slice(0, 4));
                                    }}
                                />
                                <span>-</span>
                                <Input
                                    inputType="text"
                                    placeholder="4567"
                                    width={"fill"}
                                    value={boardDetailStore.listInnerData?.["tel03"]}
                                    onChange={(e) => {
                                        boardDetailStore.setCooperationDataList("tel03", e.target.value.replace(/\D/g, '').slice(0, 4));
                                    }}
                                />
                            </div>
                        </div>
                    </TitleContentInner>
                    <TitleContentInner>
                        <div className={"title"}>홈페이지 주소</div>
                        <div className={"content"}>
                            <Input
                                inputType="text"
                                placeholder="홈페이지 주소를 입력해주세요"
                                width={"fill"}
                                value={boardDetailStore.listInnerData?.["homepageUrl"]}
                                onChange={(e) => {
                                    boardDetailStore.setCooperationDataList("homepageUrl", e.target.value);
                                }}
                            />
                        </div>
                    </TitleContentInner>
                    <TitleContentInner>
                        <div className={"title"}>로고파일</div>
                        <div className={"content"}>
                            <FileUploadArea className={"view-img"}>
                                <div className={"file-wrap"}
                                     onClick={setFileUpload}
                                >
                                    <input
                                        className={"file-hide-input"}
                                        ref={hideFiles}
                                        type="file"
                                        multiple
                                        accept=".jpg,.jpeg,.png,.gif"
                                        onChange={(e) =>
                                            fileUpload(e, {
                                                prevFiles: boardDetailStore.formFile,
                                                onAfter: boardDetailStore.setFormFilesData,
                                                maxSizeMB: parseInt(boardDetailStore.currentBoardContent.options.file.size.split("MB")[0]),
                                                multiple: true,
                                                maxFiles: boardDetailStore.currentBoardContent.options.file.count,
                                                type: "admin",
                                                imgPreview: true,
                                                accepts: [".jpg", ".jpeg", ".png", ".gif"],
                                            })
                                        }
                                    />
                                    <div className={"file-input-wrap"}>
                                        <Input
                                            inputType="text"
                                            placeholder="jpg, jpeg .png, gif"
                                            width={"fill"}
                                            readOnly={true}
                                        />
                                        <div className={"file-search-btn"}>
                                            <BsPaperclip size={24} color="#999"/>
                                        </div>
                                    </div>
                                </div>
                                <ImportInfo className={"mg"}>*로고 파일 넓이: 200px, 높이: 80px로 업로드 해 주세요.</ImportInfo>
                                {boardDetailStore.formFile &&
                                    boardDetailStore.formFile.length > 0 && (
                                        <div className={"file-list-info"}>
                                            {boardDetailStore.formFile.map((item, idx) => {
                                                const src = boardDetailStore.imagePreviewMap[idx];
                                                return (
                                                    <div className={"file-item-wrap"} key={idx}>
                                                        <div
                                                            className={"cancel-btn"}
                                                            onClick={() => boardDetailStore.setRemoveFormFile(idx)}
                                                        >
                                                            <IoCloseCircleOutline size={20} color={"#999"} />
                                                        </div>
                                                        {src ? (
                                                            <img
                                                                className="file-item-image"
                                                                src={src}
                                                                alt={item?.name || `banner-${idx}`}
                                                            />
                                                        ) : (
                                                            <div className="file-item-fallback">
                                                                미리보기를 불러올 수 없습니다.
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                {/*{boardDetailStore.formFile && boardDetailStore.formFile.length > 0 && (*/}
                                {/*    <div className={"file-list-info"}>*/}
                                {/*        {boardDetailStore.formFile.map((item, idx) => (*/}
                                {/*            <div className={"file-item-wrap"} key={idx}>*/}
                                {/*                <div*/}
                                {/*                    className={"cancel-btn"}*/}
                                {/*                    onClick={() => boardDetailStore.setRemoveFormFile(idx)}*/}
                                {/*                >*/}
                                {/*                    <IoCloseCircleOutline size={20} color={"#999"}/>*/}
                                {/*                </div>*/}
                                {/*                <div className={"file-item-name"}*/}
                                {/*                     onClick={async () => {*/}
                                {/*                         let file = item;*/}
                                {/*                         if (typeof item === "string") {*/}
                                {/*                             file = JSON.parse(item);*/}
                                {/*                         }*/}
                                {/*                         const url = file.path;*/}
                                {/*                         if (!url) return;*/}
                                {/*                         const name = file.name || "";*/}
                                {/*                         const targetForCheck = (name || url).toLowerCase();*/}
                                {/*                         const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(targetForCheck);*/}
                                {/*                         const isPdf = /\.pdf$/.test(targetForCheck);*/}
                                {/*                         if (isImage || isPdf) {*/}
                                {/*                             // 이미지 또는 PDF → 새창 열기*/}
                                {/*                             window.open(url, "_blank", "noopener,noreferrer");*/}
                                {/*                         } else {*/}
                                {/*                             await downloadFile(file.path, file.name);*/}
                                {/*                         }*/}
                                {/*                     }}*/}
                                {/*                >{item.name}</div>*/}
                                {/*            </div>*/}
                                {/*        ))}*/}
                                {/*    </div>*/}
                                {/*)}*/}
                            </FileUploadArea>
                        </div>
                    </TitleContentInner>
                    <TitleContentInner>
                        <div className={"title"}>공개유무<RequiredStar>*</RequiredStar></div>
                        <div className={"content"}>
                            <div className={"is-active-wrap"}>
                                <SelectBox
                                    option={IS_ACTIVE_LIST}
                                    size="m"
                                    type="solid"
                                    round={true}
                                    placeholder="선택"
                                    onChange={async (e) => {
                                        boardDetailStore.setCooperationDataList("isActive", e.value);
                                    }}
                                    value={IS_ACTIVE_LIST.find(opt => opt.value === boardDetailStore.listInnerData?.["isActive"]) || null}
                                />
                            </div>
                        </div>
                    </TitleContentInner>
                </TitleContentWrap>
                <ButtonWrap className={"center cooperation-btn-wrap"} $gap={10}>
                    <Button
                        type="solid"
                        size="m"
                        round={true}
                        text={"취소"}
                        onClickFunc={async () => {
                            handleCloseModal(modalDepth);
                        }}
                    />
                    <Button
                        type="fill"
                        size="m"
                        round={true}
                        text={`${data ? "수정" : "등록"}`}
                        onClickFunc={async () => {

                            if(!boardDetailStore.listInnerData?.["locationTitle"]){
                                setToast("warning", "지역명을 선택해 주세요.");
                                return;
                            }
                            if(!boardDetailStore.listInnerData?.["title"]){
                                setToast("warning", "기업명을 입력해 주세요.");
                                return;
                            }

                            if(!boardDetailStore.listInnerData?.["address"]){
                                setToast("warning", "주소 찾기를 해주세요.");
                                return;
                            }

                            if(!boardDetailStore.listInnerData?.["isActive"]){
                                setToast("warning", "공개유무를 선택해 해주세요.");
                                return;
                            }
                            // tel01 tel02 tel03
                            if(boardDetailStore.listInnerData?.["tel01"]){
                                if(!boardDetailStore.listInnerData?.["tel02"] || !boardDetailStore.listInnerData?.["tel03"]){
                                    setToast("warning", "번호를 정확히 입력해 주세요.");
                                    return;
                                }
                                if(boardDetailStore.listInnerData?.["tel01"].length <= 1){
                                    setToast("warning", "휴대전화 형식이 올바르지 않습니다.");
                                    return;
                                }
                            }
                            if(boardDetailStore.listInnerData?.["tel02"]){
                                if(!boardDetailStore.listInnerData?.["tel01"] || !boardDetailStore.listInnerData?.["tel03"]){
                                    setToast("warning", "번호를 정확히 입력해 주세요.");
                                    return;
                                }
                                if(boardDetailStore.listInnerData?.["tel02"].length <= 2){
                                    setToast("warning", "휴대전화 형식이 올바르지 않습니다.");
                                    return;
                                }
                            }
                            if(boardDetailStore.listInnerData?.["tel03"]){
                                if(!boardDetailStore.listInnerData?.["tel01"] || !boardDetailStore.listInnerData?.["tel02"]){
                                    setToast("warning", "번호를 정확히 입력해 주세요.");
                                    return;
                                }
                                if(boardDetailStore.listInnerData?.["tel03"].length <= 3){
                                    setToast("warning", "휴대전화 형식이 올바르지 않습니다.");
                                    return;
                                }
                            }
                            try {
                                const root = getCurrentNode(menuStore.menuTreeList, menuId)?.trail[0];
                                const response =  await boardDetailStore.setBoardFormData(menuId, data, undefined, root.menuId);
                                if(response){
                                    boardDetailStore.setBoardFormDataReset();
                                    setToast("success", "등록 되었습니다.")
                                    confirmFunc();
                                }
                            } catch (e) {

                            }
                        }}
                    />
                </ButtonWrap>
            </CooperationModalWrap>
        </ModalBody>
    )
});
const CooperationModalWrap = styled.div`
    .uni-cont{
        flex-direction: column;
        gap: 5px;
        align-items: start;
    }
    .loc-wrap {
        display: flex;
        align-items: center;

        .loc-name {
            width: 40%;
            flex-shrink: 0;

            .loc-name-select {
                width: 100%;

                .react-select__menu {
                    width: 100%;
                }
            }
        }

        .cooperation-title {
            width: 100%;
        }
    }

    .is-active-wrap {
        width: 150px;

        .react-select__menu {
            width: 100%;
        }
    }

    .tel-wrap {
        display: flex;
        align-items: center;
        gap: 5px;

        .input-wrapper {
            width: 100px;
        }
    }
    .cooperation-btn-wrap {
        margin-top: 24px;
    }
`
export default CooperationAddModal;
export const LOC_LIST = [
    {label: "서울/경기/인천", value: "서울/경기/인천"},
    {label: "강원도", value: "강원도"},
    {label: "충청북도", value: "충청북도"},
    {label: "충청남도", value: "충청남도"},
    {label: "전라북도", value: "전라북도"},
    {label: "전라남도", value: "전라남도"},
    {label: "경상북도", value: "경상북도"},
    {label: "경상남도", value: "경상남도"},
    {label: "제주특별자치도", value: "제주특별자치도"},
    {label: "부산광역시", value: "부산광역시"},
    {label: "대구광역시", value: "대구광역시"},
    {label: "인천광역시", value: "인천광역시"},
    {label: "광주광역시", value: "광주광역시"},
    {label: "대전광역시", value: "대전광역시"},
    {label: "울산광역시", value: "울산광역시"},
]

const IS_ACTIVE_LIST = [
    {label: "공개", value: "active"},
    {label: "비공개", value: "hidden"},
]


